import { createApp, defineAsyncComponent } from "vue";

/**
 * Creates and mounts a new vue instance for memberships
 *
 * @param {Function} onCreated
 */
const initialise = (onCreated) => {
	const app = createApp();

	app.component(
		"membership-app",
		defineAsyncComponent(() => import("@app/memberships/MembershipApp.vue"))
	);

	app.component(
		"basket-widget",
		defineAsyncComponent(() => import("@app/products/Basket-Widget.vue"))
	);

	app.component(
		"basket-app",
		defineAsyncComponent(() => import("@app/products/Basket.vue"))
	);

	app.component(
		"basket-checkout",
		defineAsyncComponent(() => import("@app/products/BasketCheckout.vue"))
	);

	app.component(
		"basket-confirmation",
		defineAsyncComponent(() => import("@app/products/BasketConfirmation.vue"))
	);

	app.component(
		"basket-add-button",
		defineAsyncComponent(() => import("@app/products/basket-parts/BasketAddButton.vue"))
	);

	app.component(
		"event-booking-app",
		defineAsyncComponent(() => import("@app/booking/Booking-App.vue"))
	);

	app.component(
		"fac-search",
		defineAsyncComponent(() => import("@app/fac-search/FACSearch.vue"))
	);

	app.component(
		"fac-multi-search-header",
		defineAsyncComponent(() => import("@app/fac-search/FACMultiSearchHeader.vue"))
	);

	app.component(
		"fac-search-header",
		defineAsyncComponent(() => import("@app/fac-search/FACSearchHeader.vue"))
	);

	app.component(
		"fac-search-result",
		defineAsyncComponent(() => import("@app/fac-search/FACSearchResult.vue"))
	);

	app.component(
		"account-settings",
		defineAsyncComponent(() => import("@app/account/AccountSettings.vue"))
	);

	app.component(
		"acc-my-profile",
		defineAsyncComponent(() => import("@app/account/MyProfile.vue"))
	);

	app.component(
		"acc-public-profile",
		defineAsyncComponent(() => import("@app/account/PublicProfile.vue"))
	);

	app.component(
		"acc-my-memberships",
		defineAsyncComponent(() => import("@app/account/MyMemberships.vue"))
	);

	app.component(
		"acc-my-renewals",
		defineAsyncComponent(() => import("@app/account/MyRenewals.vue"))
	);

	app.component(
		"accordion",
		defineAsyncComponent(() => import("@app/components/accordion/Refactored/Accordion.vue"))
	);

	app.component(
		"accordion-item",
		defineAsyncComponent(() => import("@app/components/accordion/Refactored/AccordionItem.vue"))
	);

	app.component(
		"tabs",
		defineAsyncComponent(() => import("@app/components/tabs/Slotted/Tabs.vue"))
	);

	app.component(
		"tab-panel",
		defineAsyncComponent(() => import("@app/components/tabs/Slotted/TabPanel.vue"))
	);

	app.mount("#page");
};

export default initialise;
